import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userDoc: {},
    routes: {},
    
    buyback: {
      dialog: '',
      dialog_fee: '',
      dialog_sale: '',
      transaction_id: '',
      client_id: ''
    },

    order: {
      dialog: '',
      transaction_id: '',
      client_id: ''
    },

    reconcile: {
      dialog: '',
      transaction_id: '',
      client_id: ''
    },

    farmer: {
      dialog: '',
      transaction_id: '',
      client_id: ''
    },

    outsideBusiness: {
      products: {},
      product_tmp: {},
      dialog: false,
      dialog_type: 'image',
      product_id: '203'
    },

    outsideBusinessPayment: {
      dialog: false,
      transaction_id: '',
      supplier_id: '',
      operation: '',
    },

    transfer: {
      dialog: false,
      transaction_id: '',
      client_id: ''
    },

    membership: {
      view_dialog: false,
      member_id: '',
      customer_type: '',
      tab_items: [],
      headers: {
        steps: [],
        profile: '',
        buttons: [],
      },

      basicInfoDialog: true,
      customerTypeDialog: false,
      membershipDetailDialog: false,
      basicInfo: {},
    },
  },

  mutations: {
    updateBuybackDialogPayment (state, payload) {
      if(payload.dialog !== undefined) { state.buyback.dialog = payload.dialog }
      if(payload.dialog_fee !== undefined) { state.buyback.dialog_fee = payload.dialog_fee }
      if(payload.dialog_sale !== undefined) { state.buyback.dialog_sale = payload.dialog_sale }
     
      state.buyback.transaction_id  =  payload.transaction_id;
      state.buyback.client_id       =  payload.client_id;
    },

    updateStockReconcileDialogPayment (state, payload) {
      state.reconcile.dialog          =  payload.dialog;
      state.reconcile.transaction_id  =  payload.transaction_id;
      state.reconcile.client_id       =  payload.client_id;
    },

    updateOrderDialogPayment (state, payload) {
      state.order.dialog          =  payload.dialog;
      state.order.transaction_id  =  payload.transaction_id;
      state.order.client_id       =  payload.client_id;
    },

    updateFarmerDialogPayment (state, payload) {
      state.farmer.dialog          =  payload.dialog;
      state.farmer.transaction_id  =  payload.transaction_id;
      state.farmer.client_id       =  payload.client_id;
    },

    updateTransferDialogPayment (state, payload) {
      state.transfer.dialog          =  payload.dialog;
      state.transfer.transaction_id  =  payload.transaction_id;
      state.transfer.client_id       =  payload.client_id;
    },

    updateOutsideBusinessDialog (state, payload) {
      state.outsideBusiness.dialog_type =  payload.dialog_type;
      state.outsideBusiness.dialog      =  payload.dialog;
    },

    updateViewMembershipDialog (state, payload) {
      state.membership.view_dialog  =  payload.view_dialog;
      state.membership.member_id    =  payload.member_id;
      state.membership.customer_type=  payload.customer_type;
    },

    updateViewMembershipDialogTabItem (state, payload) {
      state.membership.tab_items         =  payload.tab_items;
      state.membership.tab_items_loading =  payload.tab_items_loading;
    },

    updateOutsideBusinessProduct (state, payload) {
      state.outsideBusiness.products = payload;
    },

    updateOutsideBusinessProductTmp (state, payload) {
      state.outsideBusiness.product_tmp    =  payload;
    },

    updateOutsideBusinessProductId (state, payload) {
      state.outsideBusiness.product_id = payload;
    },

    updateEcoBusinessDialogPayment (state, payload) {
      state.outsideBusinessPayment.dialog         = payload.dialog;
      state.outsideBusinessPayment.transaction_id = payload.transaction_id;
      state.outsideBusinessPayment.supplier_id = payload.supplier_id;
      if(payload.operation){ // sale_orde | purchase_order
        state.outsideBusinessPayment.operation = payload.operation;
      }
    },

    updateBasicInfoDialog (state, payload) {
      state.membership.basicInfoDialog = payload;
    },

    updateCustomerTypeDialog (state, payload) {
      state.membership.customerTypeDialog = payload;
    },

    updateMembershipDetailDialog (state, payload) {
      state.membership.membershipDetailDialog = payload;
    },

    updateViewMembershipHeader (state, payload) {
      state.membership.headers.steps   = payload.steps;
      state.membership.headers.profile = payload.profile;
      state.membership.headers.buttons = payload.buttons;
    },

    updateRoute(state, payload){
      state.routes  = payload;
    }
  },

  actions: {
    /** payload is boolean tru | false */
    updateBuybackDialogPayment (context, payload) {
      context.commit('updateBuybackDialogPayment', payload);
    },

    /** payload is boolean tru | false */
    updateStockReconcileDialogPayment (context, payload) {
      context.commit('updateStockReconcileDialogPayment', payload);
    },

    /** payload is boolean tru | false */
    updateOrderDialogPayment (context, payload) {
      context.commit('updateOrderDialogPayment', payload);
    },

    updateTransferDialogPayment (context, payload) {
      context.commit('updateTransferDialogPayment', payload);
    },


    
    /** payload is boolean tru | false */
    updateFarmerDialogPayment (context, payload) {
      context.commit('updateFarmerDialogPayment', payload);
    },

    /** payload is object */
    updateOutsideBusinessDialog (context, payload) {
      context.commit('updateOutsideBusinessDialog', payload);
    },

    /** payload is object */
     updateOutsideBusinessProduct (context, payload) {
      context.commit('updateOutsideBusinessProduct', payload);
    },

    /** payload is object */
    updateOutsideBusinessProductTmp (context, payload) {
      context.commit('updateOutsideBusinessProductTmp', payload);
    },
    
    /** payload is object */
    updateOutsideBusinessProductId (context, payload) {
      context.commit('updateOutsideBusinessProductId', payload);
    },

    /** payload is object */
    updateEcoBusinessDialogPayment (context, payload) {
      context.commit('updateEcoBusinessDialogPayment', payload);
    },

    /** payload is boolean tru | false */
    updateBasicInfoDialog (context, payload) {
      context.commit('updateBasicInfoDialog', payload);
    },

    /** payload is boolean tru | false */
    updateCustomerTypeDialog (context, payload) {
      context.commit('updateCustomerTypeDialog', payload);
    },

    /** payload is boolean tru | false */
    updateMembershipDetailDialog (context, payload) {
      context.commit('updateMembershipDetailDialog', payload);
    },

    updateViewMembershipDialog (context, payload) {
      context.commit('updateViewMembershipDialog', payload);
    },

    updateViewMembershipDialogTabItem (context, payload) {
      context.commit('updateViewMembershipDialogTabItem', payload);
    },

    updateViewMembershipHeader (context, payload) {
      context.commit('updateViewMembershipHeader', payload);
    },
    
    updateRoute(context, payload){
      context.commit('updateRoute', payload);
    }
  },
  modules: {}
});
